export default __webpack_public_path__ + "static/media/pokemon_ground.ca01199f.png";